<button
    type="button"
    class="info-button"
    ctrlTooltip
    [ctrlTooltipConfig]="{ position: 'left-top', offsetY: 12, offsetX: -24 }"
>
    <ctrl-tooltip class="-top-right">
        @if (heading() !== undefined) {
            <div class="fw:bold m-6:b">
                {{ heading() }}
            </div>
        }
        {{ text() }}
    </ctrl-tooltip>
</button>
